import {NgModule} from '@angular/core';
import {CUSTOMERS} from '@infrastructure/http/customer/customers';
import {HttpCustomersService} from '@infrastructure/http/customer/http-customers.service';
import {HttpProductionOrdersService} from '@infrastructure/http/production-order/http-production-orders.service';
import {PRODUCTION_ORDERS} from '@infrastructure/http/production-order/production-orders';
import {HttpProductionSchedulesService} from '@infrastructure/http/production-schedule/http-production-schedules.service';
import {PRODUCTION_SCHEDULES} from '@infrastructure/http/production-schedule/production-schedules';
import {HttpTexfabService} from '@infrastructure/http/texfab/http-texfab.service';
import {TEXFAB} from '@infrastructure/http/texfab/texfab';
import {SharedModule} from '@shared/shared.module';
import {AgGridModule} from 'ag-grid-angular';
import {ProductionScheduleOverviewCreelPreviewComponent} from './production-schedule/overview/creel-preview/production-schedule-overview-creel-preview.component';
import {texfabRouting} from './texfab.routing';

@NgModule({
  declarations: [ProductionScheduleOverviewCreelPreviewComponent],
  imports: [texfabRouting, SharedModule, AgGridModule],
  providers: [
    {provide: PRODUCTION_SCHEDULES, useClass: HttpProductionSchedulesService},
    {provide: CUSTOMERS, useClass: HttpCustomersService},
    {provide: PRODUCTION_ORDERS, useClass: HttpProductionOrdersService},
    {provide: TEXFAB, useClass: HttpTexfabService}
  ]
})
export class TexfabModule {}
